/* global google */

const MAP_ELEMENT_ID = "contact-offices-map";
const NEAREST_ELEMENT_ID = "contact-nearest-office";
const EXCLUDED_OFFICE_SLUGS = ["skolbemanning", "global"];
const SWEDEN_CENTER = { lat: 61.751, lng: 14.631 };

/** Location pin path (keep in sync with themes/clockwork/img/map-pointer.svg). */
const MAP_POINTER_PATH_D =
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5";
const MAP_POINTER_FILL = "#f6ad48";

function haversineDistanceKm(a, b) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);

    const h =
        Math.sin(dLat / 2) ** 2 +
        Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
    return 2 * R * Math.asin(Math.sqrt(h));
}

/**
 * DOM marker content for google.maps.marker.AdvancedMarkerElement (vector map).
 * Uses inline SVG so the pin is not dependent on image requests or img hit areas.
 */
function createOfficeMarkerContent(officeName) {
    const wrap = document.createElement("div");
    wrap.style.cursor = "pointer";
    wrap.style.lineHeight = "0";
    wrap.setAttribute("role", "img");
    wrap.setAttribute("aria-label", officeName);

    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "36");
    svg.setAttribute("height", "36");
    svg.setAttribute("aria-hidden", "true");

    const path = document.createElementNS(svgNS, "path");
    path.setAttribute("fill", MAP_POINTER_FILL);
    path.setAttribute("d", MAP_POINTER_PATH_D);

    svg.appendChild(path);
    wrap.appendChild(svg);
    return wrap;
}

function isGeolocationAllowedContext() {
    if (typeof window === "undefined") {
        return false;
    }
    /*if (typeof window.isSecureContext === "boolean") {
        return window.isSecureContext;
    }*/
    const { protocol, hostname } = window.location;
    return (
        protocol === "https:" ||
        hostname === "localhost" ||
        hostname === "127.0.0.1"
    );
}

function getVisitorPosition() {
    return new Promise((resolve) => {
        if (!("geolocation" in navigator)) {
            resolve(null);
            return;
        }

        // Browsers only expose geolocation on HTTPS or localhost; plain HTTP
        // staging URLs get "Only secure origins are allowed" if we call the API.
        if (!isGeolocationAllowedContext()) {
            resolve(null);
            return;
        }

        const timer = setTimeout(() => {
            resolve(null);
        }, 6000);

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                clearTimeout(timer);
                resolve({
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                });
            },
            (error) => {
                clearTimeout(timer);
                resolve(null);
            },
            { maximumAge: 600000, timeout: 5000 },
        );
    });
}

function renderNearestOffice(office, distanceKm) {
    const wrap = document.getElementById(NEAREST_ELEMENT_ID);
    if (!wrap || !office) {
        return;
    }

    const nameEl = wrap.querySelector("[data-nearest-name]");
    const distanceEl = wrap.querySelector("[data-nearest-distance]");
    const ctaEl = wrap.querySelector("[data-nearest-cta]");

    if (nameEl) {
        nameEl.textContent = office.name;
    }
    if (distanceEl && typeof distanceKm === "number") {
        const display =
            distanceKm < 1
                ? `${Math.round(distanceKm * 1000)} m från dig`
                : `${distanceKm.toFixed(1)} km från dig`;
        distanceEl.textContent = display;
    }
    if (ctaEl) {
        ctaEl.setAttribute("href", `/kontakta-oss/${office.slug}`);
    }

    wrap.classList.remove("contact-page__nearest--hidden");

    const card = document.querySelector(`[data-office-slug="${office.slug}"]`);
    if (card) {
        card.classList.add("contact-support__card--highlight");
        const tag = card.querySelector(".contact-support__card__tag");
        if (tag && !tag.dataset.defaultLabel) {
            tag.dataset.defaultLabel = tag.textContent || "";
            tag.textContent = "Närmast dig";
        }
    }
}

window.initMap = function initMap() {
    const mapEl =
        document.getElementById(MAP_ELEMENT_ID) ||
        document.getElementById("map");
    if (!mapEl) {
        return;
    }

    void (async () => {
        try {
            const { AdvancedMarkerElement } =
                await window.google.maps.importLibrary("marker");

            const mapId =
                typeof window.GOOGLE_MAP_ID === "string" && window.GOOGLE_MAP_ID
                    ? window.GOOGLE_MAP_ID
                    : "DEMO_MAP_ID";

            // Advanced markers require a map ID. Vector maps ignore the
            // legacy `styles` option; attach a Cloud style to GOOGLE_MAP_ID
            // (see resources/map-styles/).
            const map = new window.google.maps.Map(mapEl, {
                center: SWEDEN_CENTER,
                scrollwheel: true,
                zoom: 5,
                mapId,
                mapTypeControl: false,
                streetViewControl: false,
            });

            $.getJSON("/wp-json/clockwork/v1/offices", function (data) {
                const offices = (data || []).filter(
                    (o) =>
                        !EXCLUDED_OFFICE_SLUGS.includes(o.slug) &&
                        o.lat &&
                        o.lng,
                );

                offices.forEach((office) => {
                    const lat = parseFloat(office.lat);
                    const lng = parseFloat(office.lng);
                    const href = `/kontakta-oss/${office.slug}`;

                    const content = createOfficeMarkerContent(office.name);

                    const marker = new AdvancedMarkerElement({
                        map,
                        position: { lat, lng },
                        title: office.name,
                        content,
                        gmpClickable: true,
                    });

                    marker.addListener("click", () => {
                        window.location.href = href;
                    });
                });

                if (document.getElementById(NEAREST_ELEMENT_ID)) {
                    getVisitorPosition().then((position) => {
                        if (!position) {
                            return;
                        }

                        let nearest = null;
                        let nearestDistance = Infinity;

                        offices.forEach((office) => {
                            const d = haversineDistanceKm(position, {
                                lat: parseFloat(office.lat),
                                lng: parseFloat(office.lng),
                            });
                            if (d < nearestDistance) {
                                nearest = office;
                                nearestDistance = d;
                            }
                        });

                        if (nearest) {
                            renderNearestOffice(nearest, nearestDistance);
                            map.setCenter({
                                lat: parseFloat(nearest.lat),
                                lng: parseFloat(nearest.lng),
                            });
                            map.setZoom(7);
                        }
                    });
                }
            }).fail(function () {
                console.error("Error requesting offices data");
            });
        } catch (err) {
            console.error(
                "Clockwork map: advanced markers failed to load",
                err,
            );
        }
    })();
};
